import React from 'react';
import { McBookieMainLogoWrapper, McBookieMainLogo } from './mcbookie.style';
import { UniverseSwitcher } from 'src/components/UniverseSwitcher/UniverseSwitcher';

export const McbookieLogotype = (): JSX.Element => (
    <McBookieMainLogoWrapper>
        <McBookieMainLogo />
        <UniverseSwitcher />
    </McBookieMainLogoWrapper>
);
